import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Text,
  Select,
  SimpleGrid,
} from "@chakra-ui/react";

interface VehicleInfoCardProps {
  isCarMakerDisabled?: boolean;
  licensePlateNumber: string;
  carModel: string;
  vinNumber: string;
  carMaker: string;
  carMakersData?: any[];
  isLoadingMakers?: boolean;
  onLicensePlateChange: (value: string) => void;
  onCarModelChange: (value: string) => void;
  onVinNumberChange: (value: string) => void;
  onCarMakerChange: (value: string) => void;
  hideCarMaker?: boolean;
  isLicensePlateNumberRequired?: boolean;
}

const VehicleInfoCard: React.FC<VehicleInfoCardProps> = ({
  isCarMakerDisabled,
  licensePlateNumber,
  carModel,
  vinNumber,
  carMaker,
  carMakersData,
  isLoadingMakers,
  onLicensePlateChange,
  onCarModelChange,
  onVinNumberChange,
  onCarMakerChange,
  hideCarMaker = false,
  isLicensePlateNumberRequired = false,
}) => (
  <Box width="100%">
    <Box mb={5} borderBottom="1px solid lightgrey" pb={2}>
      <Text fontWeight="bold">Vehicle Information</Text>
    </Box>
    <VStack spacing={4} align="stretch">
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 3, md: 4 }}>
        {!hideCarMaker && (
          <FormControl>
            <FormLabel fontSize="smaller" fontWeight="medium">
              Select Maker*
            </FormLabel>
            <Select
              placeholder={isLoadingMakers ? "Loading..." : "Select..."}
              value={carMaker}
              onChange={(e) => onCarMakerChange(e.target.value || "")}
              bgColor="white"
              isDisabled={isCarMakerDisabled}
            >
              {carMakersData?.map((maker: any, idx: number) => {
                const name = maker.name || maker.makerName || "";
                return (
                  <option key={idx} value={name}>
                    {name}
                  </option>
                );
              })}
            </Select>
          </FormControl>
        )}
        <FormControl>
          <FormLabel fontSize="smaller" fontWeight="medium">
            {"License Plate Number" +
              (isLicensePlateNumberRequired ? " *" : "")}
          </FormLabel>
          <Input
            placeholder={
              "License Plate Number" +
              (isLicensePlateNumberRequired ? " *" : "")
            }
            value={licensePlateNumber}
            onChange={(e) =>
              onLicensePlateChange(e.target.value?.toUpperCase() || "")
            }
            bgColor="white"
            maxLength={10}
            required={isLicensePlateNumberRequired}
          />
        </FormControl>
      </SimpleGrid>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 3, md: 4 }}>
        <FormControl>
          <FormLabel fontSize="smaller" fontWeight="medium">
            Car Model
          </FormLabel>
          <Input
            placeholder="Enter car model"
            value={carModel}
            onChange={(e) => onCarModelChange(e.target.value)}
            bgColor="white"
          />
        </FormControl>
        <FormControl>
          <FormLabel fontSize="smaller" fontWeight="medium">
            VIN Number
          </FormLabel>
          <Input
            placeholder="Enter VIN number"
            value={vinNumber}
            onChange={(e) =>
              onVinNumberChange(e.target.value?.toUpperCase() || "")
            }
            bgColor="white"
            maxLength={17}
          />
        </FormControl>
      </SimpleGrid>
    </VStack>
  </Box>
);

export default VehicleInfoCard;
